var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#4FFF8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9996 12.8334C8.78551 12.8334 7.3164 12.5755 5.49957 12.2223C5.08462 12.1422 4.27734 12.2223 4.27734 13.4445C4.27734 15.889 7.0854 18.9445 10.9996 18.9445C14.9131 18.9445 17.7218 15.889 17.7218 13.4445C17.7218 12.2223 16.9145 12.1416 16.4996 12.2223C14.6827 12.5755 13.2136 12.8334 10.9996 12.8334Z",
    fill: "#0F4421"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13.4445C5.5 13.4445 7.33333 14.0556 11 14.0556C14.6667 14.0556 16.5 13.4445 16.5 13.4445C16.5 13.4445 15.2778 15.8889 11 15.8889C6.72222 15.8889 5.5 13.4445 5.5 13.4445Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33344 10.3889C8.17721 10.3889 8.86122 9.43125 8.86122 8.24997C8.86122 7.0687 8.17721 6.11108 7.33344 6.11108C6.48967 6.11108 5.80566 7.0687 5.80566 8.24997C5.80566 9.43125 6.48967 10.3889 7.33344 10.3889Z",
    fill: "#0F4421"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6664 10.3889C15.5102 10.3889 16.1942 9.43125 16.1942 8.24997C16.1942 7.0687 15.5102 6.11108 14.6664 6.11108C13.8227 6.11108 13.1387 7.0687 13.1387 8.24997C13.1387 9.43125 13.8227 10.3889 14.6664 10.3889Z",
    fill: "#0F4421"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.33b5afea79440f5efb5e678e5aad4ad1.svg";
export { ForwardRef as ReactComponent };